import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {   
    BaasicFormControls,
    BaasicButton,
    ApplicationEmptyState,
    BaasicModal
} from 'core/components';
import {PageFooter, EditFormLayout} from 'core/layouts';
import { UserEditPartialForm } from 'application/user/components';
import { UserPasswordChange, UserEmailSignatureEditModal } from 'application/user/pages';

function UserProfileEditTemplate({ userEditViewStore, t }) {
    const {
        form,
        rootStore,
        loaderStore,
        openChangePassword,
        changePasswordModal,
        emailSignatureEditModal,
        openChangeEmailSignature
    } = userEditViewStore;
    return (
        <EditFormLayout store={userEditViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        <h3 className="u-mar--bottom--sml">General Data</h3>
                        <UserEditPartialForm form={form} />
                    </div>
                </div>
                <div className="col col-sml-12 col-lrg-4">
                    <div className="card card--form card--primary card--med u-mar--bottom--med">
                        <h3 className="u-mar--bottom--sml">Actions</h3> 
                            <ul>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={openChangePassword}><span className="u-icon u-icon--sml form__icon form__icon--reset-pass u-mar--right--tny" /> Change Password</a>
                                </li>
                            </ul>
                            <ul>
                                <li className="u-mar--bottom--sml">
                                    <a onClick={openChangeEmailSignature}><span className="u-icon u-icon--envelope--primary u-icon--sml u-mar--right--tny" /> Change Email Signature</a>
                                </li>
                            </ul>
                    </div>
                </div>
            </div>

            <BaasicModal modalParams={changePasswordModal} className="modal__content modal--sml">
                <UserPasswordChange/>
            </BaasicModal>

            <BaasicModal modalParams={emailSignatureEditModal} className="modal__content modal--lrg">
                <UserEmailSignatureEditModal/>
            </BaasicModal>

            {renderEditLayoutFooterContent({
                form,
                t,
                goBack: () => rootStore.routerStore.goBack()
            })}
        </EditFormLayout>
    )
}

UserProfileEditTemplate.propTypes = {
    userEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

function renderEditLayoutFooterContent({ form, goBack, t }) {
    return <PageFooter>
                <BaasicFormControls form={form} onSubmit={form.onSubmit}/>
                <BaasicButton
                    className="btn btn--base btn--ghost"
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={goBack}
                />
            </PageFooter>
}

renderEditLayoutFooterContent.propTypes = {
    form: PropTypes.any,
    goBack: PropTypes.func,
    t: PropTypes.func
};

export default defaultTemplate(UserProfileEditTemplate);
